module.exports = __webpack_public_path__ + "static/media/umb_logo.66ba087a.svg";